export function SetConsentValues(currentValue: boolean, prevValue: boolean): boolean | null {
  if (prevValue == true) {
    switch (currentValue) {
      //Si Consentement true avant et reste pareil on ne fais pas de modifications
      case true:
        return null;
      //Si Consentement true avant on le retire on applique le Withdrawn
      case false:
        return false;
    }
  } else {
    switch (currentValue) {
      //Si Consentement false avant et maintenant true on applique Active
      case true:
        return true;
      //Si Consentement false avant et reste pareil on ne fais pas de modifications
      case false:
        return null;
    }
  }
}
